export default (engine, db, contentType, disable) => {
  const fieldByType = Object.fromEntries((contentType.item || []).map((item) => [item.id, item.extends || item.type]));
  fieldByType._crdate = "date";
  const run = (method, args, fallback) => {
    try {
      return engine[method](...args);
    } catch (error) {
      if (!(error instanceof WebAssembly.RuntimeError)) throw error;
      disable(error);
      return fallback;
    }
  };

  return {
    stats: { searches: 0, fallbacks: 0 },
    free: () => engine.free(),
    reset() {
      engine.clear();
    },
    save: (data, position) => run("save", [JSON.stringify(data), position]),
    delete: (id) => run("delete", [id]),
    clear: () => run("clear", []),
    size: () => run("size", [], 0),
    get: (id) => {
      if (typeof id !== "string") return;
      const data = run("get", [id]);
      return data === undefined ? undefined : JSON.parse(data);
    },
    find({ field, value, testIfSet }) {
      if (
        !testIfSet &&
        ((value && typeof value === "object") || (typeof value === "number" && !Number.isFinite(value)))
      )
        return false;
      const data = run(
        "find",
        [
          field,
          JSON.stringify(testIfSet ? !!value : value === undefined ? null : value),
          !!testIfSet,
          value === undefined,
        ],
        false,
      );
      if (data === false) return false;
      return { data: data === undefined ? undefined : JSON.parse(data) };
    },
    search(query, getFilter) {
      this.stats.searches++;
      const groups = [];
      let supported =
        Number.isSafeInteger(query.position) &&
        query.position >= 0 &&
        Number.isSafeInteger(query.count) &&
        query.count >= 0;
      if (query.filter) {
        const { searchField = [], searchValue = [], searchInvert = [] } = getFilter(query);
        searchField.forEach((fields, index) => {
          groups.push(
            fields.map((field, position) => {
              const value = searchValue[index][position];
              const predicate = { field, invert: !!searchInvert[index][position], kind: "never" };
              if (value === "false" || value === "true") predicate.kind = value === "false" ? "falsy" : "truthy";
              else if (value[0] === "<" || value[0] === ">") {
                predicate.kind = value[0] === "<" ? "lt" : "gt";
                predicate.number = parseFloat(value.substring(1));
                if (!Number.isFinite(predicate.number)) supported = false;
              } else if (value instanceof RegExp) {
                predicate.kind = "literal";
                predicate.literals = value.source.split("|").map((text) => {
                  const start = text.startsWith("^");
                  const end = text.endsWith("$") && !text.endsWith("\\$");
                  if (start) text = text.slice(1);
                  if (end) text = text.slice(0, -1);
                  // Keep JS RegExp for syntax requiring its regex engine or Unicode case folding.
                  if (!/^(?:[a-zA-Z0-9 _:@,=<>!%#&;~`'"/-]|\\[.*+?^${}()[\]\\/])*$/u.test(text)) supported = false;
                  return { text: text.replace(/\\(.)/g, "$1").toLowerCase(), start, end };
                });
              }
              return predicate;
            }),
          );
        });
      }
      const sortby = Array.isArray(query.sortby) ? query.sortby : [query.sortby];
      const reverse = Array.isArray(query.reverse) ? query.reverse : [query.reverse || false];
      const sort =
        sortby.length === 1 && sortby[0] === "_chdate"
          ? []
          : sortby.map((key, index) => ({
              key,
              kind: ["int", "date"].includes(fieldByType[key])
                ? "number"
                : fieldByType[key] === "reference"
                  ? "reference"
                  : "text",
              reverse: !!reverse[index],
            }));
      const result =
        supported &&
        run(
          "search",
          [JSON.stringify({ groups, sort, reverse: !!reverse[0], position: query.position, count: query.count })],
          false,
        );
      if (!result) {
        this.stats.fallbacks++;
        return false;
      }
      const { ids, total, searchTotal } = JSON.parse(result);
      return { total, searchTotal, data: ids.length ? ids.map((id) => JSON.parse(engine.get(id))) : false };
    },
  };
};
